import React from "react";
import { FAQS } from "@/data/content";
import {
  Accordion, AccordionContent, AccordionItem, AccordionTrigger,
} from "@/components/ui/accordion";

export const FAQ = () => {
  return (
    <section id="faq" data-testid="faq-section" className="relative py-24 md:py-32 bg-charcoal/40">
      <div className="max-w-3xl mx-auto px-6 md:px-12">
        <div className="text-center mb-14">
          <span className="text-xs font-bold tracking-[0.25em] uppercase text-vitality">FAQ</span>
          <h2 className="font-heading text-4xl sm:text-5xl font-black uppercase tracking-tight mt-4 leading-tight">
            Questions, Answered
          </h2>
        </div>

        <Accordion type="single" collapsible className="space-y-4">
          {FAQS.map((item, i) => (
            <AccordionItem
              key={i}
              value={`item-${i}`}
              data-testid={`faq-${i}`}
              className="bg-charcoal border border-white/10 rounded-xl px-6 data-[state=open]:border-vitality/40"
            >
              <AccordionTrigger className="font-heading text-lg uppercase tracking-tight hover:no-underline hover:text-vitality text-left py-5">
                {item.q}
              </AccordionTrigger>
              <AccordionContent className="text-white/60 leading-relaxed pb-5">
                {item.a}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </div>
    </section>
  );
};
